<template>
  <div class="tabsContent1">

    <div class="main-con">

      <div class="table-con">
        <div class="nodata-table" v-if="nodata">
         暂无数据
        </div>
        <table v-if="!nodata" style="border: 1px solid rgb(225, 235, 240); border-collapse: collapse;width: 100%;">
          <tr class="tab-img">
            <td></td>
            <td>电流（A）</td>
            <td>电流谐波（A）</td>
            <td>基波电流（A）</td>
            <td>电压（V）</td>
            <td>功率因数</td>
            <td>有功功率（W）	</td>
            <td>基波功率（W）</td>
            <td>视在功率（W）</td>
            <td>有功电度（Kwh）</td>
            <td>温度（℃）</td>
<!--            <td>合相电能（Kwh）</td>-->
          </tr>
          <tr>
            <td>A相</td>
            <td>{{ alldata.Ia?alldata.Ia.value:"-" }}</td>
            <td>{{ alldata.Iax?alldata.Iax.value:"-" }}</td>
            <td>{{ alldata.Iab? alldata.Iab.value:"-" }}</td>
            <td>{{ alldata.Ua?alldata.Ua.value:"-" }}</td>

            <td>{{ alldata.PFa?alldata.PFa.value:"-" }}</td>
            <td>{{ alldata.Pa?alldata.Pa.value:"-" }}</td>
            <td>{{ alldata.Pba?alldata.Pba.value:"-" }}</td>

            <td>{{ alldata.Sa?alldata.Sa.value:"-" }}</td>
            <td>{{ alldata.Wa?alldata.Wa.value:"-" }}</td>
            <td>{{ alldata.Ta=='-45.0'?"-":alldata.Ta.value}}</td>
<!--            <td>-</td>-->
          </tr>
          <tr>
            <td>B相</td>
            <td>{{ alldata.Ib?alldata.Ib.value:"-" }}</td>
            <td>{{ alldata.Ibx?alldata.Ibx.value:"-" }}</td>
            <td>{{ alldata.Ibb? alldata.Ibb.value:"-" }}</td>
            <td>{{ alldata.Ub?alldata.Ub.value:"-" }}</td>

            <td>{{ alldata.PFb?alldata.PFb.value:"-" }}</td>
            <td>{{ alldata.Pb?alldata.Pb.value:"-" }}</td>
            <td>{{ alldata.Pbb?alldata.Pbb.value:"-" }}</td>

            <td>{{ alldata.Sb?alldata.Sb.value:"-" }}</td>
            <td>{{ alldata.Wb?alldata.Wb.value:"-" }}</td>
            <td>{{ alldata.Tb=='-45.0'?"-":alldata.Tb.value}}</td>
<!--            <td>-</td>-->
          </tr>
          <tr>
            <td>C相</td>
            <td>{{ alldata.Ic?alldata.Ic.value:"-" }}</td>
            <td>{{ alldata.Icx?alldata.Icx.value:"-" }}</td>
            <td>{{ alldata.Icb? alldata.Icb.value:"-" }}</td>
            <td>{{ alldata.Uc?alldata.Uc.value:"-" }}</td>

            <td>{{ alldata.PFc?alldata.PFc.value:"-" }}</td>
            <td>{{ alldata.Pc?alldata.Pc.value:"-" }}</td>
            <td>{{ alldata.Pbc?alldata.Pbc.value:"-" }}</td>

            <td>{{ alldata.Sc?alldata.Sc.value:"-" }}</td>
            <td>{{ alldata.Wc?alldata.Wc.value:"-" }}</td>
            <td>{{ alldata.Tc=='-45.0'? "-":alldata.Tc.value}}</td>
<!--            <td>-</td>-->
          </tr>
          <tr>
            <td>剩余电流(mA)</td>
            <td>{{ alldata.In? alldata.In.value:"-" }}</td>
            <td>{{ alldata.Inx? alldata.Inx.value:"-" }}</td>
            <td>{{ alldata.Inb? alldata.Inb.value:"-" }}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>{{ alldata.Tn=='-45.0'?"-":alldata.Tn.value }}</td>
<!--            <td>{{ alldata.Wc?Number(alldata.Wc.value) + Number(alldata.Wa.value) + Number(alldata.Wb.value):"-" }}</td>-->
          </tr>
        </table>
      </div>

    </div>


  </div>
</template>

<script>
import Axios from "@/utils/Axios";
import Vue from "vue";

export default {
  name: "tabsContent1",

  data() {
    return {
      loginName:null,
      branchId:null,
      activeName:"first",
      intervalId:'',
      nodata:false,
      alldata:{
        branchName: null,
        electricity: null,
        feederCurrent: null,
        frequency: null,
        fundamentalCurrent: null,
        harmonicCurrent: null,
        insulationResistance: null,
        loadCurrent: null,
        loadPower: null,
        loadPowerFactor: null,
        loadReactivePower: null,
        onOffState: null,
        remainingPower: null,
        residualCurrent:null,
        residualFundamentalCurrent: null,
        residualHarmonicCurrent: null,
      },

    };

  },
  mounted() {

    let that=this
    this.loginName=localStorage.getItem('loginName');
    this.gettabledata()

  },
  methods: {
    handleClick(){},
    gettabledata(){

      let that = this;
      let param = {};
      param.method="get";
      param.url="/analogData/analogDataInfo";
      param.params={
        "monitorSiteId":sessionStorage.getItem("saveid"),
        // "branchId":"5-2",

      }
      Axios.ajax(param).then((res)=>{

        if(res.resultCode=='0'){
          that.nodata=false
          that.alldata=res.data
        }else{
          that.nodata=true
          // this.$alert('当前监测点无数据',sessionStorage.getItem("branchId"), {
          //   confirmButtonText: '确定',
          //   callback: action => {
          //     that.$router.push("/stationPage/stationList");
          //   }
          // });
        }

      })
    },

  },
  watch: {

  },
  destroyed() {

  },
  components: {

  }
};
</script>
<style lang="less" rel="stylesheet/less" scoped>
.tabsContent1{
  height: 100%;

  padding:10px;
  .main-con{
    background-color: #fff;

    padding:10px;
    margin-top: 10px;
  }
  .sb-dir{
    width: 300px;
    .sb-group{
      span{

        margin-right: 10px;

      }
    }
  }
  .top-con{
    width: calc(100% - 20px);
    height: 90px;
    display: flex;
    justify-content:flex-start;
    align-items:center;
    padding: 10px 20px 0 20px;
    line-height: 30px;
    background: #fff;
    .blue-name{
      display: inline-block;
      //background: url("../../../assets/station/bluebg.jpg") no-repeat;

      padding-left: 15px;
    }
    .blue-bor{
      background: #f0f5fc;
      border: 1px solid #a0c4f3;
      color: #306fd3;
      padding: 0 20px;
      height: 36px;
      line-height: 36px;
      margin-left: 20px;
      margin-top: 6px;
      font-size: 14px;
      display: inline-block;
      img{
        position: relative;
        top: 4px;
        margin-right: 10px;
      }
      .blue-item{
        margin-right: 20px;
      }
    }
  }
  .nodata-table{
    width: 100%;
    height:240px;
    line-height: 240px;
    text-align: center;
  }
  .table-con{
    width: 100%;
    height:240px;
    td{
      text-align: center;
      border-bottom: 1px dashed #ddd;
      padding: 3px;
      height: 40px;
      background-color: rgba(0,0,0,0.02);
    }

    //td{
    //  text-align: center;
    //  border: 1px solid #e1ebf0;
    //  padding: 3px;
    //}
    //tr:nth-child(even){
    //  background-color: #f4f9fc;
    //}
    .tab-img{
      img{
        width: 40px;
        padding: 10px 0 4px;
      }

    }
  }
  .cav-con{

    padding-left: 10px;
    box-sizing: border-box;
    position: relative;
    height:340px;
    overflow: auto;
    border: 1px solid #ddd;

  }
}
</style>
<style lang="less">
#app .tabsContent1 .search-blank {
  .el-tabs--border-card > .el-tabs__content {
    padding: 0;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 175px;
  }
  .el-input__inner {
    width: 175px;
    height: 30px;
    line-height: 28px;
  }
  .el-input__icon {
    line-height: 28px;
  }
}
#app .tabsContent1 .el-pagination.is-background .el-pager li:not(.disabled).active{
  color: #fff;
}
#app .tabsContent1 .el-select-dropdown__wrap{
  max-heigt:300px;
}
</style>
